import { DatoExportType } from '@common/enums/datoExportType';

type DatoExportTypeOptions = {
    [key in DatoExportType]: {
        activityType: string;
        monthLabel: string;
        monthType: string;
        tooltipText?: string;
    };
};

export const datoExportTypeOptions: DatoExportTypeOptions = {
    [DatoExportType.followUp]: {
        activityType: 'Follow-up',
        monthLabel: 'Periode',
        monthType: 'follow-up maand',
    },
    [DatoExportType.screening]: {
        activityType: 'Medische screening',
        monthLabel: 'Maand operatiedata',
        monthType: 'operatiemaand',
        tooltipText:
            'Hiermee selecteer je de periode waarin patiënten geopereerd zijn, om van hen de medische screening te exporteren die zij eerder hebben gehad.',
    },
};
